import { OgObject } from 'networking/mindfeed/types/OgObject';

// What cortex scraped from a page: its Open Graph title, image and favicon.
export type UrlPreview = OgObject;

// The page's main image, if it has one.
export const imageOf = (preview?: UrlPreview): string | undefined =>
  preview?.ogImage?.[0]?.url;

// The page's favicon as an absolute address. The scraper returns it either
// absolute or as a root-relative path, which is resolved against the page
// itself. Anything else (a bare file name, no page) gives nothing.
export const faviconOf = (preview?: UrlPreview): string | undefined => {
  const favicon = preview?.favicon;
  const requestUrl = preview?.requestUrl;
  if (!favicon) {
    return undefined;
  }
  if (favicon.startsWith('http')) {
    return favicon;
  }
  if (favicon.startsWith('/') && requestUrl) {
    try {
      return new URL(favicon, requestUrl).href;
    } catch {
      return undefined;
    }
  }
  return undefined;
};
